import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=54ec4521"
import script from "./Relatorio.vue?vue&type=script&lang=js"
export * from "./Relatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports